import React from 'react';
import queryString from 'query-string';
import {connect} from 'react-redux';
import {Link} from 'react-router-dom';
import ApiActions from 'go/actions/api';
import {API_COMMENT_GET_SUCCESS, API_COMMENT_GET_FAILURE} from 'common/types';
import {Container, Breadcrumb, Grid, Loader, Dimmer, Segment} from 'semantic-ui-react';
import Main from 'app-ui-componentlibrary/dist/go/components/layout/main';
import Error from 'app-ui-componentlibrary/dist/go/components/common/error';
import CommentController from 'go/components/comments/CommentController';

export class CommentPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      comments: [],
      loading: true,
      backLink: '/',
      error: false,
    };
  }

  UNSAFE_componentWillMount() {
    const grantId = this.props.match.params.grantId;
    const token = this.props.token;
    const queries = queryString.parse(this.props.location.search);
    const backLink = queries.ref || '/';
    this.props
      .retrieveComments(token, grantId)
      .then((res) => {
        if (res.type === API_COMMENT_GET_SUCCESS) {
          this.setState({
            comments: res.payload,
            backLink: backLink,
            loading: false,
            error: false,
          });
        } else {
          this.setState({
            loading: false,
            error: true,
            backLink: backLink,
          });
        }
        return res;
      })
      .catch((err) => {
        this.setState({
          loading: false,
          error: true,
          backLink: backLink,
        });
      });
  }

  renderNoComments() {
    return <Segment>No comments were found for this grant.</Segment>;
  }

  renderMain() {
    const {comments, loading, error} = this.state;
    const noCommentsView = this.renderNoComments();
    if (loading) {
      return (
        <Dimmer active inverted>
          <Loader inverted />
        </Dimmer>
      );
    } else if (error) {
      return noCommentsView;
    } else {
      return <CommentController comments={comments} header="Comments" controls={false} />;
    }
  }

  render() {
    const {backLink} = this.state;
    const mainContent = this.renderMain();
    return (
      <Main>
        <Container fluid>
          <Grid>
            <Grid.Row>
              <Breadcrumb>
                <Breadcrumb.Section link>
                  <Link to={backLink} title="navigate back">
                    Back
                  </Link>
                </Breadcrumb.Section>
                <Breadcrumb.Divider />
                <Breadcrumb.Section>Comments</Breadcrumb.Section>
              </Breadcrumb>
            </Grid.Row>
            <Grid.Row centered>
              <Grid.Column mobile={16} computer={12}>
                {/* TODO, probably need to show award number somewhere */}
                {mainContent}
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Container>
      </Main>
    );
  }
}

export const mapDispatchToProps = (dispatch) => {
  return {
    retrieveComments: (token, grantId, phase) => {
      const action = ApiActions.comments.getCommentsForGrant(token, grantId, phase);
      const response = dispatch(action);
      return response;
    },
  };
};

export const mapStateToProps = (state) => {
  return {
    token: state.auth.token,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CommentPage);
